var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{staticClass:"text",attrs:{"type":"primary"}},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('p',{key:_vm.text.id},[_c('i',{staticClass:"el-icon-s-opportunity"}),_vm._v(" 公告："+_vm._s(_vm.text.val)+"\n      ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }